export function capitalize(value) {
    return (value.at(0).toUpperCase() + value.slice(1));
}
export function uncapitalize(value) {
    return (value.at(0).toLowerCase() + value.slice(1));
}
